import { IWhiteListData } from  '@/interfaces/passkeys'
import { BasicButton, SimpleTable } from 'thrive-components'


const WhitelistData = ({whitelistTableContent, canViewRequests, onRemoveRestrictionClick, onViewRequests, onAddIPAddress, onCreateCodeClick, canCreateRecoveryCode} :IWhiteListData) => {  

    return(
        <div className="whitelist-data-container">
            <label className='passkey-label'>
                IP WHITELIST
            </label>

            <div className="whitelist-explainer-text">
                Add trusted IP addresses to protect against unauthorised access. Only IP addresses added will be allowed to make account recovery requests or use sign-in codes from another device.
            </div>

            <SimpleTable
                {...whitelistTableContent}
            />

            <div className='whitelist-button-panel'>
                <BasicButton 
                    content={"Remove IP Restriction"} 
                    onButtonClick={onRemoveRestrictionClick}
                    ariaLabel={'Remove IP Restriction'}
                />
                
                <BasicButton 
                    content={"Add IP Address"} 
                    onButtonClick={onAddIPAddress}
                    ariaLabel={'Add IP Address'}
                />

                {canViewRequests &&<>
                    <BasicButton 
                        content={"View Requests"} 
                        onButtonClick={onViewRequests}
                        ariaLabel={'View Requests'}
                    />

                    <BasicButton 
                        className='create-code-button'
                        content={"Create Code"} 
                        ariaLabel={'Create Code'} 
                        onButtonClick={onCreateCodeClick} 
                        isDisabled={!canCreateRecoveryCode}
                    />
                </>}
            </div>
        </div>
    )
}

export default WhitelistData